module.exports = __webpack_public_path__ + "static/media/manage1.959fa855.jpg";